import React, { Component } from 'react'
import PropTypes from 'prop-types'

class EventDeleteRiderRequestModal extends Component {
  render() {
    const { riderRequest } = this.props

    return (
      <div className="modal-content">
        <h3>Rider request</h3>

        {
          riderRequest.user
          ? <p>{riderRequest.statusMessage} ({riderRequest.user.email})</p>
          : <p>{riderRequest.statusMessage} ({riderRequest.user_request.email})</p>
        }

        {
          riderRequest.description
          ? <p>Description: {riderRequest.description}</p>
          : null
        }

        <button className="button--primary" onClick={() => this.props.deleteRiderRequest()}>Remove request</button>
      </div>
    )
  }
}

EventDeleteRiderRequestModal.propTypes = {
  riderRequest: PropTypes.object,
  deleteRiderRequest: PropTypes.func,
  setModal: PropTypes.func
}

EventDeleteRiderRequestModal.defaultProps = {
  riderRequest: {},
  deleteRiderRequest: function() {},
  setModal: function() {}
}

export default EventDeleteRiderRequestModal



// WEBPACK FOOTER //
// ./src/components/modals/event-delete-rider-request-modal.js